import React from "react"
import CommonModal from "../CommonModal";
import Button from "../../Elements/Button";
import "../../Admin/Shared/AdminModal.css";

const DeleteOrgModal = ({ title, openModal, closeModal, name, handleDelete }) => {
    return (<>
        <CommonModal
            title={title ?? "Are you sure?"}
            modalStatus={openModal}
            changeActiveStatus={(status) => closeModal()}
            classList="header-profile-modal-wrapper alert-modal admin-confirmation-modal"
            showFooter={false}
            centered
        >
            <div className="admin-confirmation-modal-body">
                <p className="admin-confirmation-modal-message">
                    Do you really want to {name ?? ''}? This process cannot be undone.
                </p>
                <div className="admin-confirmation-modal-actions">
                    <Button text="Yes" type="button" classList="primary1" addonClass="admin-confirmation-yes common-modal-yes-button" onClick={() => handleDelete()} />
                    <Button text="No" classList="primary" addonClass="admin-confirmation-no" onClick={() => closeModal()} />
                </div>
            </div>
        </CommonModal>
    </>)
}
export default DeleteOrgModal